import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPost, doPut } from 'api/request';
import type {
  CreateHandoffRequest,
  EditHandoffRequest,
  HandoffResponse,
  HandoffsResponse,
} from 'api/resources/handoff/types';
import { LOGGER_TYPE } from 'api/types';
import { pick } from 'lib/miscHelper';
import { generateNextPath } from 'lib/routeHelper';

export const getHandoffs = (accountId: string, projectId: string) => {
  return doGet<HandoffsResponse>(
    generateNextPath(ENDPOINTS.HANDOFFS, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    { version: 'v2' },
  );
};

export const createHandoffConfig = ({
  accountId,
  projectId,
  request,
}: {
  accountId: string;
  projectId: string;
  request: CreateHandoffRequest;
}) => {
  return doPost<HandoffResponse>(
    generateNextPath(ENDPOINTS.HANDOFFS, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    request,
    { version: 'v2' },
  );
};

export const editHandoffConfig = ({
  accountId,
  projectId,
  request: { id: handoffId, ...request },
}: {
  accountId: string;
  projectId: string;
  request: EditHandoffRequest;
}) => {
  return doPut<HandoffResponse>(
    generateNextPath(ENDPOINTS.HANDOFF, {
      accountId,
      projectId,
      handoffId: handoffId ?? null,
    }),
    LOGGER_TYPE.JUPITER,
    pick(
      request,
      'name',
      'description',
      'sip_type',
      'sip_config',
      'sip_headers',
    ),
    { version: 'v2' },
  );
};

export const deleteHandoffConfig = ({
  accountId,
  projectId,
  handoffId,
}: {
  accountId: string;
  projectId: string;
  handoffId: string;
}) => {
  return doDelete(
    generateNextPath(ENDPOINTS.HANDOFF, {
      accountId,
      projectId,
      handoffId,
    }),
    LOGGER_TYPE.JUPITER,
    {},
    { version: 'v2' },
  );
};

export const updateDefaultHandoff = ({
  accountId,
  projectId,
  handoffId,
}: {
  accountId: string;
  projectId: string;
  handoffId: string;
}) => {
  return doPut<{ handoffs: HandoffResponse[] }>(
    generateNextPath(ENDPOINTS.DEFAULT_HANDOFF, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    {
      handoff_id: handoffId,
    },
    { version: 'v2' },
  );
};
